import config from 'Cloud/config';
import store from 'lib/store';
import { COUNTDOWN_DATA, SPACE_COUNTDOWN_ID } from 'reactApp/ui/Space/SpaceCountdown/SpaceCountdown.data';

const IS_AUTO_TEST_HIDE = config.get('IS_AUTO_TEST_HIDE');
const SPACE_PROMO = config.get('SPACE_PROMO');

export const getSpacePromoConfig = (userPercentUsed) => {
    return (SPACE_PROMO || []).find((CONFIG) => {
        const { min_quota = 0, max_quota = 99 } = CONFIG;
        return min_quota < userPercentUsed && userPercentUsed < max_quota;
    });
};

export const getPromoCountdownEndDate = (userEmail) => {
    let endDate = store.get(`${userEmail}|promo-countdown_${SPACE_COUNTDOWN_ID}`);
    if (!endDate) {
        const now = new Date();
        endDate = new Date().setDate(now.getDate() + 1);
        store.set(`${userEmail}|promo-countdown_${SPACE_COUNTDOWN_ID}`, endDate);
    }
    return endDate;
};

export const getPromoCountdown = (userEmail, userPercentUsed) => {
    const now = new Date();
    const endDate = getPromoCountdownEndDate(userEmail);
    const show = userPercentUsed < 7 && now < endDate;
    return show && !IS_AUTO_TEST_HIDE && COUNTDOWN_DATA;
};
